var _path, _path2, _path3, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentReceived(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10C13.9477 10 13.5 10.4477 13.5 11C13.5 11.5523 13.9477 12 14.5 12V10ZM8.5 12C9.05228 12 9.5 11.5523 9.5 11C9.5 10.4477 9.05228 10 8.5 10V12ZM25 13V22H27V13H25ZM24 23H8V25H24V23ZM7 22V13H5V22H7ZM14.5 12H24V10H14.5V12ZM8 12H8.5V10H8V12ZM8 23C7.44772 23 7 22.5523 7 22H5C5 23.6569 6.34315 25 8 25V23ZM25 22C25 22.5523 24.5523 23 24 23V25C25.6569 25 27 23.6569 27 22H25ZM27 13C27 11.3431 25.6569 10 24 10V12C24.5523 12 25 12.4477 25 13H27ZM7 13C7 12.4477 7.44772 12 8 12V10C6.34315 10 5 11.3431 5 13H7Z",
    fill: "#0BC196"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17V16H25H20C18.8954 16 18 16.8954 18 18C18 19.1046 18.8954 20 20 20H25H26V19V17Z",
    stroke: "#0EF1BC",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.4873L10.4896 17.3782C11.0101 18.0389 12.0091 18.0463 12.5394 17.3934L14.0875 15.4873",
    stroke: "#24D1A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 8,
    y2: -1,
    transform: "matrix(0 -1 -1 0 10.6211 15)",
    stroke: "#0EF1BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentReceived);
export default __webpack_public_path__ + "static/media/paymentReceived.53f49e4090361e5af6fa970e41af1193.svg";
export { ForwardRef as ReactComponent };